<template>
  <v-layout wrap>
    <v-flex xs12 sm12 class="mx-3 mb-2">
      <v-toolbar dense flat color="toolbarColor">All Jobs</v-toolbar>
    </v-flex>

    <v-flex
      v-if="jobs && jobs.length>=1"
      xs12
      sm12
      v-for="job in jobs"
      v-bind:key="job._id"
      class="list-section pa-2 mx-3 mb-0 mb-3"
    >
      <div>
        <div>
          <div class="right mt-2" v-if="job.is_vip_featured == true">
            <v-chip color="orange" dark small><v-icon color="white"></v-icon>Featured</v-chip>
          </div>
          <h3 class="headline mb-0">{{job.title}}</h3> 
        </div>
        <div v-html="trimJobText(job.description)"></div>
        <h4>Time Frame: <span class="font-weight-regular">{{job.timeFrame}}</span></h4>
        <h4 v-if="job.active == true && job.assigned == false && job.expired==false">Job Status: <span class="jobStatus">Available</span></h4>
        <h4><strong>Primary Job Location: </strong> <span class="font-weight-regular">{{job.location.locationName}}</span></h4>
        <h4 v-if="job.is_vip_featured == true && (job.userId.locationOne || job.userId.locationTwo || job.userId.locationThree || job.userId.locationForu)"><strong>Additional Preferred Expert Locations: </strong> <span class="font-weight-regular" v-if="job.userId.locationOne">
        {{job.userId.locationOne.locationName}}</span>
        <span class="font-weight-regular" v-if="job.userId.locationTwo">
        : {{job.userId.locationTwo.locationName}}</span>
        <span class="font-weight-regular" v-if="job.userId.locationThree">
        : {{job.userId.locationThree.locationName}}</span>
        <span class="font-weight-regular" v-if="job.userId.locationFour">
        : {{job.userId.locationFour.locationName}}</span>
        </h4>
        <h4>Posted On: <span class="font-weight-regular">{{job.createdAt | moment("DD MMMM YYYY") }}</span></h4>
      </div>
      <div class="text-xs-left">
        <v-chip color="orange" dark small>{{job.category}}</v-chip>
      </div>

      <div>
        <v-btn flat color="btnColor" :to="`/expert/job/details/${job._id}`">More Details</v-btn>
        <v-btn
        v-if="job.active == true && job.assigned == false && job.bidStatus == false && job.expired == false"
          flat
          color="engageColor"
          outline
          round
          class="right"
          :loading="activeJobId==job._id"
          @click="engageSonko(job)"
        >Bid Job</v-btn>
         <span v-if="job.expired == true || job.status == 'expired'" style="color: red" class="right">Expired</span>
         <span v-else-if="job.active == true && job.assigned == true" style="color: red" class="right">Assigned</span>
         <span v-else-if="job.active == false" style="color: red" class="right">Job Unavailable</span>
         
         <br>
        <span v-if="job.bidStatus == true" style="color: green" class="right">Bid Submitted</span>
      </div>
    </v-flex>
    <v-flex v-if="jobs.length<1" sm-12 class="list-section pa-2 mx-3 mb-3 text-xs-center">
      <span style="color: #b71c1c;" >No Jobs in the location or/and within the Expertise</span>
    </v-flex>
    <!-- notofication  -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-toolbar color="blue darken-2" flat dense dark>
          <v-toolbar-title class="title">Bid Successful</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click="close">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>Your bid has been submitted. The sonko will contact you.</v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of notification -->
  </v-layout>
</template>

<script>
import { trimJobText } from "@/common/methods.js";
import { mapGetters } from "vuex";
export default {
  name: "LandingJobsIndex",
  computed: {
    ...mapGetters(["user"])
  },
  props: {
    jobs: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dialog: false,
      activeJobId: null,
      loader: false
    };
  },
  methods: {
    trimJobText,
    engageSonko(job) {
      const data = {
        sonko: job.userId,
        jobId: job._id,
        userId: this.user._id
      };
      this.activeJobId = job._id;
      // send request
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/engagement", data })
        .then(res => {
          self.activeJobId = null;
          location.reload();
        })
        .finally(() => {
          self.dialog = true;
        });
      // end
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
<style type="text/css">
  .jobStatus {
    color: #008000;
  }
</style>